var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Process } from "../../../../lib/process/process.cls";
var SecurityMasterPatcher = /** @class */ (function (_super) {
    __extends(SecurityMasterPatcher, _super);
    function SecurityMasterPatcher(iProvider) {
        var _this = _super.call(this, iProvider) || this;
        // vuex store to make remote api calls
        _this.vuexStore = null;
        _this.vuexStore = iProvider.getStore();
        _this.log(SecurityMasterPatcher.TAG, 'pid', _this.settings.pid);
        return _this;
    }
    /**
     * @Override
     * start process thread
     * used by caches and providers and mains to start all
     * registered providers and caches
     * @param params
     */
    SecurityMasterPatcher.prototype.start = function (params) {
        this.log(SecurityMasterPatcher.TAG, 'start', params);
        this.settings = params;
    };
    /**
     * @Override
     * stop process thread
     * used by caches and providers and mains to stop all
     * registered providers and caches
     * @param params
     */
    SecurityMasterPatcher.prototype.stop = function (params) {
        this.log(SecurityMasterPatcher.TAG, "stop done");
    };
    /**
     * @Override
     * authenticate
     * uses the credentials inside params in case auth is needed
     * @param params
     */
    SecurityMasterPatcher.prototype.auth = function (params) { };
    /**
     * decorate an expired cache item
     * @param iCacheable
     */
    SecurityMasterPatcher.prototype.decorate = function (iCacheable) {
        // this.vuexStore.dispatch(
        //   PriceFeedProviderConst.RUN_LOAD_PATCH, 
        //   {
        //     // to patch the right provider via mutation 
        //     cacheItemTag: this.iProvider.settings.cacheItemTag,
        //     // remote endpount
        //     target: "https://staging.finvasia.com:3000/" + "Scripsearch",
        //     // target: "https://69.167.152.107:3000/" + "Scripsearch",
        //     // date format to compute yesterday
        //     dateformat:this.settings.DW_EP_CLOSE_PRICE_DF,
        //     // cache id
        //     key:iCacheable.key
        //   })
    };
    SecurityMasterPatcher.TAG = 'SecurityMasterPatcher';
    return SecurityMasterPatcher;
}(Process));
export { SecurityMasterPatcher };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/vue-provider-cache/provider/ws-price-feed/patcher/security-master-patcher.cls.ts
// module id = null
// module chunks = 